__turbopack_context__.v({
  "actions": "search-bar-mobile-module-scss-module__A0h-KW__actions",
  "chevronDownIcon": "search-bar-mobile-module-scss-module__A0h-KW__chevronDownIcon",
  "close": "search-bar-mobile-module-scss-module__A0h-KW__close",
  "close1": "search-bar-mobile-module-scss-module__A0h-KW__close1",
  "closeIcon": "search-bar-mobile-module-scss-module__A0h-KW__closeIcon",
  "container": "search-bar-mobile-module-scss-module__A0h-KW__container",
  "mobileContainer": "search-bar-mobile-module-scss-module__A0h-KW__mobileContainer",
  "mobileOverlay": "search-bar-mobile-module-scss-module__A0h-KW__mobileOverlay",
  "navbar": "search-bar-mobile-module-scss-module__A0h-KW__navbar",
  "search": "search-bar-mobile-module-scss-module__A0h-KW__search",
  "searchBar": "search-bar-mobile-module-scss-module__A0h-KW__searchBar",
  "searchBarVisible": "search-bar-mobile-module-scss-module__A0h-KW__searchBarVisible",
  "searchButton": "search-bar-mobile-module-scss-module__A0h-KW__searchButton",
  "searchButtonMobile": "search-bar-mobile-module-scss-module__A0h-KW__searchButtonMobile",
  "searchDynacastBy": "search-bar-mobile-module-scss-module__A0h-KW__searchDynacastBy",
  "searchIcon": "search-bar-mobile-module-scss-module__A0h-KW__searchIcon",
  "searchInput": "search-bar-mobile-module-scss-module__A0h-KW__searchInput",
  "searchInputBar": "search-bar-mobile-module-scss-module__A0h-KW__searchInputBar",
  "searchInputBarMobile": "search-bar-mobile-module-scss-module__A0h-KW__searchInputBarMobile",
  "searchInputMobile": "search-bar-mobile-module-scss-module__A0h-KW__searchInputMobile",
  "searchOverlayVisible": "search-bar-mobile-module-scss-module__A0h-KW__searchOverlayVisible",
  "searchPlaceholder": "search-bar-mobile-module-scss-module__A0h-KW__searchPlaceholder",
  "searchTitleMobile": "search-bar-mobile-module-scss-module__A0h-KW__searchTitleMobile",
  "searchWrapper": "search-bar-mobile-module-scss-module__A0h-KW__searchWrapper",
  "slideDown": "search-bar-mobile-module-scss-module__A0h-KW__slideDown",
});
